import { Component, Input, OnInit, Self, AfterContentInit, Optional } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';

@Component({
  selector: 'form-input',
  templateUrl: './input.component.html',
  // providers: [{
  //   provide: NG_VALUE_ACCESSOR,
  //   useExisting: InputComponent,
  //   multi: true
  // }]
})
export class InputComponent implements OnInit, ControlValueAccessor {
  // @Input() form: string;
  @Input() model: string;
  @Input() icon: string;
  @Input() type = 'text';

  @Input() name: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() required = false;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() maxlength: number;
  @Input() pattern: string;
  @Input() list: string;
  @Input() data: string;
  @Input()
  get value(): string {
    if (!this._value) {
      return '';
    } else {
      return this._value;
    }
  }

  set value(value: string) {
    this._value = value;
  }

  private _value = '';

  // It will have a reference to a function that handles changing state of the control
  private _onChangeFn: (value: any) => void = _ => { };

  constructor(@Self() @Optional() public ngControl: NgControl) {

    this.ngControl.valueAccessor = this;
  }

  ngOnInit() {

  }

  onChange(event) {
    this._onChangeFn(event.target.value);
  }

  writeValue(value: any) {
    this.value = value;
  }


  registerOnChange(fn) { this._onChangeFn = fn; }

  // TODO: Implement this
  registerOnTouched(fn) { }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

}
